import {baseUrl, buildAuthRequest, buildQueryString, handleJsonResponse} from "./util/Common";

function findBuilds(hubId, limit = undefined) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}/builds${buildQueryString({limit})}`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function findBuildById(hubId, buildId) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/hubs/${hubId}/builds/${buildId}`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function createBuild(hubId, runnerId = undefined) {
    return buildAuthRequest(
        'POST',
        {'Content-Type': 'application/json'},
        JSON.stringify({"runner_id": runnerId})
    ).then((req) => {
        return fetch(`${baseUrl}/hubs/${hubId}/builds`, req);
    }).then((res) => {
        return handleJsonResponse(res);
    });
}

function deleteBuildById(hubId, buildId) {
    return buildAuthRequest(
        'DELETE',
        {'Content-Type': 'application/json'}
    ).then((req) => {
        return fetch(`${baseUrl}/hubs/${hubId}/builds/${buildId}`, req);
    }).then((res) => {
        return handleJsonResponse(res);
    });
}

export {
    findBuilds,
    findBuildById,
    createBuild,
    deleteBuildById
}